module.exports = __webpack_public_path__ + "img/remove_pedestrians2.97987630.jpg";